import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import TutorialModal from '../TutorialsModal/TutorialModal';
import TutorialIcon from '../../../../../Assets/images/Tutorial/tutorial.png';
import '../../../../../Assets/styles/LandingStyles/LandingComponentsStyles/Tutorial/TutorialButton.css';

interface TutorialButtonProps {
    text: string;
}

export const TutorialButton: React.FC<TutorialButtonProps> = ({ text }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        const tab = searchParams.get('tab');
        if (['introduction', 'getting-started', 'vs-friends', 'how-to-play'].includes(tab)) {
            setIsModalOpen(true);
        }
    }, [searchParams]);

    const openModal = () => {
        setIsModalOpen(true);
        setSearchParams({});
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSearchParams({});
    };

    return (
        <>
            <div className="tutorial_button_container" onClick={openModal} role="button">
                <img src={TutorialIcon} alt="Tutorial Icon" className="TutorialPng" />
                <span className="TutorialText">{text}</span>
            </div>
            {isModalOpen && <TutorialModal onClose={closeModal} />}
        </>
    );
};

export default TutorialButton;